export const DAIMLER_INTEGRATION_CODE = 'DAIMLER_XENTRY';
